var honorsSection = document.querySelector('.about-page-honors#honors');
var honorTitle = honorsSection.querySelector('.honors-title');
var honorsWrapper = honorsSection.querySelector('.honors-wrapper');
var projectsSection = document.querySelector('.about-page-projects');
var projectTitle = projectsSection.querySelector('.project-title');
document.addEventListener('DOMContentLoaded', function () {
    var observer = new IntersectionObserver(function (_a) {
        var entry = _a[0];
        if (entry && entry.isIntersecting) {
            honorTitle.className += ' active';
            honorsWrapper.className += ' active';
            observer.disconnect();
        }
    }, {
        rootMargin: '-150px',
    });
    observer.observe(honorsSection);
    var observer2 = new IntersectionObserver(function (_a) {
        var entry = _a[0];
        if (entry && entry.isIntersecting) {
            projectTitle.className += ' active';
            observer2.disconnect();
        }
    }, {
        rootMargin: '-150px',
    });
    observer2.observe(projectsSection);
}, false);
